export default "__VITE_ASSET__DQ1GGxyM__"